module.exports = __webpack_public_path__ + "public/SiteIcons/credit-card.svg?ace3cb20";